import ApiService from './api';

class CategoryService {
  // Get all active categories
  async getCategories(departmentId = null) {
    try {
      const queryParams = departmentId ? `?departmentId=${departmentId}` : '';
      return await ApiService.get(`/categories${queryParams}`);
    } catch (error) {
      throw error;
    }
  }

  // Get categories with pagination (admin)
  async getCategoriesPaginated(page = 0, size = 10, departmentId = null) {
    try {
      const queryParams = new URLSearchParams({
        page,
        size,
        ...(departmentId && { departmentId }),
      });

      return await ApiService.get(
        `/categories/paginated?${queryParams.toString()}`
      );
    } catch (error) {
      throw error;
    }
  }

  // Get category by ID
  async getCategoryById(id) {
    try {
      return await ApiService.get(`/categories/${id}`);
    } catch (error) {
      throw error;
    }
  }

  // Create new category (admin only)
  async createCategory(categoryData) {
    try {
      return await ApiService.post('/categories', categoryData);
    } catch (error) {
      throw error;
    }
  }

  // Update category (admin only)
  async updateCategory(id, categoryData) {
    try {
      return await ApiService.put(`/categories/${id}`, categoryData);
    } catch (error) {
      throw error;
    }
  }

  // Delete category (admin only)
  async deleteCategory(id) {
    try {
      return await ApiService.delete(`/categories/${id}`);
    } catch (error) {
      throw error;
    }
  }

  // Toggle category status (admin only)
  async toggleCategoryStatus(id) {
    try {
      return await ApiService.patch(`/categories/${id}/toggle-status`);
    } catch (error) {
      throw error;
    }
  }

  // Search categories
  async searchCategories(searchTerm) {
    try {
      return await ApiService.get(
        `/categories?search=${encodeURIComponent(searchTerm)}`
      );
    } catch (error) {
      throw error;
    }
  }
}

const categoryServiceInstance = new CategoryService();
export default categoryServiceInstance;
